import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctDecimals, FctValue } from '../../../../Fct/generics';
import { FaPlus } from 'react-icons/fa';
import { supportedContracts } from '../constants';
export var Add = createPlugin({
    protocol: 'TOKEN_MATH',
    type: 'CALCULATOR',
    method: 'add',
    description: 'Add amount1 and amount2',
    supportedContracts: supportedContracts,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                amount1: new FctValue({ isPreview: true, icon: FaPlus }),
                decimals1: new FctDecimals({}),
                amount2: new FctValue({ isPreview: true }),
                decimals2: new FctDecimals({}),
                decimalsOut: new FctDecimals({}),
            },
        },
        output: {
            result: new FctValue({
                innerIndex: 0,
            }),
        },
    }); },
});
